<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="getFactoryExportTable(1)">
                    <multiselect
                        v-model="search.factory"
                        class="form-control select border-0"
                        placeholder="ค้นหาสินค้าโรงงาน"
                        :options="optionFactory"
                        :show-labels="false"
                        :customLabel="factoryLabel"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        v-model="search.employee"
                        class="form-control select border-0"
                        placeholder="ค้นหาพนักงาน"
                        :options="optionEmployee"
                        :show-labels="false"
                        :customLabel="employeeLabel"
                        multiple
                        track-by="id">
                    </multiselect>
                    <date-picker v-model="search.date"
                                 placeholder="วันที่นำออก"
                                 :format="changeFormat"
                                 range
                                 confirm
                                 :lang="lang">
                    </date-picker>&nbsp;
                    <button @click="getFactoryExportTable(1)"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    &nbsp;
                    <button @click="pdf"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        PDF
                    </button>
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนที่จำหน่าย</th>
                    <th scope="col">วัน/เวลา ที่จำหน่าย</th>
                    <th scope="col">ผู้จำหน่าย</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in factoryExportTable">
                    <td>{{ data.employee ? data.employee.employee_no : '-' }}</td>
                    <td>{{ data.employee ? data.employee.name : '-' }}</td>
                    <td>{{ data.factory ? data.factory.code : '-' }}</td>
                    <td>{{ data.factory ? data.factory.name : '-' }}</td>
                    <td>{{ data.quantity | amount }}</td>
                    <td>{{ data.date | moment('DD/MM/YYYY') }}</td>
                    <td>{{ data.user ? data.user.name : '-' }}</td>
                    <td>
                        <a @click="getFactoryExportById(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>&nbsp;&nbsp;
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getFactoryExportTable(dataPaginate.current_page)">
        </vue-pagination>
        <b-modal hide-footer hide-header ref="export_item">
            <factory-export-modal @submit="ExportFactoryItem">
            </factory-export-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_item">
            <delete-confirm-modal @submit="deleteFactoryData"></delete-confirm-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import VuePagination from "../Pagination";
import FactoryExportModal from "./FactoryExportModal";
import DeleteConfirmModal from "../Utility/DeleteConfirmModal";
import Loading from "../Utility/Loading";
import Multiselect from "vue-multiselect";
import {domain} from "@/util/Constants";
import {mapState} from "vuex";

export default {
    name: "export-factory-product",
    components: {
        Loading,
        DeleteConfirmModal,
        FactoryExportModal,
        VuePagination,
        DatePicker,
        Multiselect
    },
    data() {
        return {
            msg: '',
            status_loading: 1,
            delete_id: '',
            optionFactory: [],
            optionEmployee: [],
            search: {
                factory: '',
                date: [],
                employee: [],
            },
            factoryExportTable: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.getFactoryExportTable(1);
        this.getFactoryEmployeeAll();
        this.getEmployeeAll();
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
        })
    },
    methods: {
        pdf() {
            let id = '';
            this.search.employee.forEach((x, i) => {
                id += i >= this.search.employee.length - 1 ? x.id : x.id + ','
            })
            let data = {
                start_date: this.search.date.length > 0 ? moment(this.search.date[0]).format('YYYY-MM-DD') : '',
                end_date: this.search.date.length > 0 ? moment(this.search.date[1]).format('YYYY-MM-DD') : '',
                factory_id: this.search.factory ? this.search.factory.id : '',
                employee_id: id,
                pdf: true
            };
            //console.log(data)
            window.open(domain + `/factory_employee_export?` +
                `factory_id=${data.factory_id}` +
                `&start_date=${data.start_date}` +
                `&end_date=${data.end_date}` +
                `&employee_id=${data.employee_id}` +
                `&user=${this.user.id}` +
                `&pdf=${data.pdf}`, '_blank')
        },
        factoryLabel(option) {
            return `${option.code} - ${option.name}`
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        getFactoryEmployeeAll() {
            this.$store.dispatch('FactoryEmployee/getFactoryEmployeeAll').then(res => {
                this.optionFactory = res;
            })
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                this.optionEmployee = res;
            })
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showExportItemModal() {
            this.$refs.export_item.show();
        },
        hideExportItemModal() {
            this.$refs.export_item.hide();
        },
        getFactoryExportTable(page) {
            let id = '';
            this.search.employee.forEach((x, i) => {
                id += i >= this.search.employee.length - 1 ? x.id : x.id + ','
            })
            let data = {
                start_date: this.search.date.length > 0 ? moment(this.search.date[0]).format('YYYY-MM-DD') : '',
                end_date: this.search.date.length > 0 ? moment(this.search.date[1]).format('YYYY-MM-DD') : '',
                factory_id: this.search.factory ? this.search.factory.id : '',
                employee_id: id,
                pdf: false
            };
            this.$store.dispatch("FactoryEmployeeExport/getFactoryEmployeeExport", {
                page,
                data,
            }).then(res => {
                this.factoryExportTable = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            })
        },
        ExportFactoryItem(value) {
            if (value) {
                let data = {
                    employee_id: value.employee_id,
                    date: value.date ? moment(value.date).format("YYYY-MM-DD") : '',
                    hr_factory_id: value.hr_factory_id,
                    quantity: value.quantity,
                    user_id: value.user_id
                }
                this.$store.dispatch("FactoryEmployeeExport/saveFactoryEmployeeExport", {
                    id: '',
                    data,
                }).then(res => {
                    if (res) {
                        this.goToExportTable();
                    } else {
                        alert("นำออกสินค้าโรงงานไม่เสร็จ");
                    }
                }).catch(() => {
                    alert("นำออกสินค้าโรงงานไม่เสร็จ");
                })
            }
            this.hideExportItemModal();
        },
        getFactoryExportById(id) {
            this.$store.dispatch("FactoryEmployeeExport/showFactoryEmployeeExport", id).then(res => {
                this.$store.dispatch("FactoryEmployeeExport/setFormFactoryEmployeeExport", res).then(() => {
                    this.showExportItemModal();
                })
            })
        },
        deleteFactoryData(value) {
            if (value && this.delete_id) {
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("FactoryEmployeeExport/deleteFactoryEmployeeExport", this.delete_id).then(() => {
                    this.getFactoryExportTable(this.dataPaginate.current_page);
                    this.msg = 'ลบรายการสำเร็จ';
                    this.status_loading = 2;
                    this.showLoadingModal();
                }).catch(() => {
                    this.msg = 'ลบรายการไม่สำเร็จ';
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
            this.hideDeleteModal();
        }

    },
}
</script>

<style scoped>

</style>
